/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */


// ran this thru claudes code refactoring 
// ran this thru claudes design



import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { FaUser } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { IoMdLogIn } from "react-icons/io";

import { customer_login, messageClear } from '../store/reducers/authReducer';

import Header from '../components/Header';
import Footer from '../components/Footer';
import SiteBadge from '../components/SiteBadge';
import GetSellerConfig from '../components/GetSellerConfig';

import { FadeLoader } from 'react-spinners';
import toast from 'react-hot-toast';
import config from '../config';

const Login = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;

    //const { seller } = useSelector(state => state.seller);
    const { loader, errorMessage, successMessage, userInfo } = useSelector(state => state.auth);

    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
        sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm, sellerProductPluralTerm,
        sellerCompanyPhoneNumber, sellerCompanyLogo,sellerSellerImage, sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
        sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
        personalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames,
        sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia
    } = GetSellerConfig();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [showPassword, setShowPassword] = useState(false);
    const [state, setState] = useState({
        webSiteOrigin: sellerFrontendURL,
        email: '',
        password: '',
    });

    const inputHandle = (e) => {
        setState(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const login = (e) => {
        e.preventDefault();
        dispatch(customer_login(state));
    };

    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            dispatch(messageClear());
        }
        if (errorMessage) {
            toast.error(errorMessage);
            dispatch(messageClear());
        }
        if (userInfo) {
            navigate('/');
        }
    }, [successMessage, errorMessage, userInfo, navigate, dispatch]);

    return (
        <div className="flex flex-col min-h-screen">
            {loader && (
                <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-black/20 backdrop-blur-sm z-[999]">
                    <FadeLoader />
                </div>
            )}
            <Header />
            <main className="flex-1 flex items-center justify-center px-4 py-8"
                style={{ backgroundColor: sellerComponentBackgroundColor }}>
                <div className="w-full max-w-sm">
                    {/* Card */}
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden "
                        style={{ 
                            borderTop: `4px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                            borderBottom: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,  
                            borderLeft: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                            borderRight: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                         }}>
                        <div className="px-8 pt-8 pb-10">
                            {/* Heading */}
                            <div className="flex items-center justify-center justify-items-center mb-8 text-left">
                                <div
                                    className="inline-flex items-center justify-center w-14 h-14 rounded-xl mb-0 mr-2">
                                    <SiteBadge  iconType='Login' iconSize={46} badgeSize={54} />
                                </div>
                                <div>
                                    <span className='leading-tight text-right font-semibold text-[20px] sm:text-[16px]' 
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        {
                                            <>Login - Welcome Back<br /><span className='font-bold' style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                                It Is Nice To See You Again
                                            </span></>
                                        }
                                    </span>
                                </div>
                            </div>
                            
                            <div className='hidden'>
                                <div className="flex items-center justify-center justify-items-center mb-8 text-center">
                                    <span
                                        className='flex items-center gap-1 px-2 py-0.5 rounded-md text-[12px] font-semibold border'
                                        style={{
                                            color: sellerPrimaryColor1,
                                            borderColor: sellerPrimaryColor1 + '40',
                                            backgroundColor: sellerPrimaryColor1 + '10',
                                        }}>
                                        <IoMdLogIn className='text-[46px] mr-0.5 opacity-60' />
                                        <span className='leading-tight text-left font-semibold text-[22px]'>
                                            {
                                                <>Welcome back<br />
                                                <span className='opacity-60 font-bold '>Tech Support</span></>
                                            }
                                        </span>
                                    </span>
                                </div>
                            </div>

                            <form onSubmit={login} className="space-y-5">

                                {/* Email */}
                                <div className="flex flex-col gap-1.5">
                                    <label
                                        htmlFor="name"
                                        className="text-xs font-semibold uppercase tracking-widest"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        Email address
                                    </label>
                                    <input
                                        onChange={inputHandle}
                                        value={state.email}
                                        className="w-full px-3.5 py-2.5 text-sm text-gray-900 placeholder-gray-400 bg-white border 
                                        border-gray-200 rounded-lg outline-none transition-all duration-150 focus:border-gray-400 
                                        focus:ring-2 focus:ring-gray-100"
                                        type="email"
                                        name="email"
                                        placeholder="you@example.com"
                                        id="email"
                                        required
                                    />
                                </div>

                                {/* Password */}
                                <div className="flex flex-col gap-1.5">
                                    <div className="flex items-center justify-between">
                                        <label
                                            htmlFor="name"
                                            className="text-xs font-semibold uppercase tracking-widest"
                                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                            Password
                                        </label>
                                        <Link
                                            to="/forgotPassword"
                                            className="text-xs font-medium hover:underline underline-offset-2 transition-colors"
                                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                            Forgot Password?
                                        </Link>
                                    </div>
                                    <div className="relative flex items-center">
                                        <input
                                            onChange={inputHandle}
                                            value={state.password}
                                            className="w-full px-3.5 py-2.5 pr-10 text-sm text-gray-900 placeholder-gray-400 bg-white border border-gray-200 rounded-lg outline-none transition-all duration-150 focus:border-gray-400 focus:ring-2 focus:ring-gray-100"
                                            type={showPassword ? 'text' : 'password'}
                                            name="password"
                                            placeholder="••••••••"
                                            id="password"
                                            required
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(prev => !prev)}
                                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors">
                                            {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                                        </button>
                                    </div>
                                </div>

                                {/* Login Button */}
                                <button
                                    type="submit"
                                    className="flex items-center justify-center gap-1 w-full py-2.5 text-md font-medium 
                                    text-white rounded-lg transition-all duration-150 hover:opacity-90 active:scale-[0.99] mt-2"
                                    style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    <IoMdLogIn size={24} />
                                    Sign in
                                </button>

                            </form>

                            {/* Divider */}
                            <div className="flex items-center gap-3 my-3">
                                <div className="flex-1 h-px bg-gray-100" />
                                <span className="text-xs text-gray-600 font-medium tracking-wide uppercase">or</span>
                                <div className="flex-1 h-px bg-gray-100" />
                            </div>

                            {/* Register */}
                            <a href={`${sellerFrontendURL}/register`}>
                                <div className="flex items-center justify-center gap-1 w-full py-2.5 text-md font-medium 
                                    border-2 rounded-lg hover:bg-gray-200 hover:border-gray-300 
                                    transition-all duration-150 active:scale-[0.99]"
                                    style={{ 
                                        color: sellerPrimaryColor1 + sellerColorSuffixDark, 
                                        borderColor: sellerPrimaryColor1 + sellerColorSuffixMedium,
                                        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
                                    }}>
                                    <FaUser size={18} className="" 
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }} />
                                    Create a new account
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Login;


//original code
// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaUser } from "react-icons/fa";
// import { RiLockPasswordFill } from "react-icons/ri";
// import { FiEye, FiEyeOff } from "react-icons/fi";
// import { IoMdLogIn } from "react-icons/io";

// import { customer_login, messageClear } from '../store/reducers/authReducer';
// import Header from '../components/Header';
// import Footer from '../components/Footer';

// import { FadeLoader } from 'react-spinners';
// import toast from 'react-hot-toast';
// import config from '../config';

// const Login = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;

//     const { seller } = useSelector(state => state.seller);
//     const { loader, errorMessage, successMessage, userInfo } = useSelector(state => state.auth);

//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;

//     const navigate = useNavigate();
//     const dispatch = useDispatch();

//     const [showPassword, setShowPassword] = useState(false);
//     const [state, setState] = useState({
//         webSiteOrigin: sellerFrontendURL,
//         email: '',
//         password: '',
//     });

//     const inputHandle = (e) => {
//         setState(prev => ({
//             ...prev,
//             [e.target.name]: e.target.value,
//         }));
//     };

//     const login = (e) => {
//         e.preventDefault();
//         dispatch(customer_login(state));
//     };

//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//         if (userInfo) {
//             navigate('/');
//         }
//     }, [successMessage, errorMessage, userInfo, navigate, dispatch]);

//     return (
//         <div>
//             {loader && (
//                 <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]'>
//                     <FadeLoader />
//                 </div>
//             )}

//             <Header />

//             <div className='min-w-screen bg-slate-200 flex justify-center items-center'>
//                 <div className='w-[350px] m-8 flex justify-center'>
//                     <div className='bg-white p-4 rounded-md shadow-lg w-full'>

//                         <h2
//                             className='flex gap-0.5 text-xl text-center items-center justify-center font-bold mb-4'
//                             style={{ color: sellerPrimaryColor1 }}
//                         >
//                             <IoMdLogIn size={25} /> Login
//                         </h2>

//                         <form onSubmit={login}>
//                             {/* Email */}
//                             <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="email">Email</label>
//                                 <input
//                                     onChange={inputHandle}
//                                     value={state.email}
//                                     className='px-3 py-2 outline-none border border-slate-400 bg-transparent rounded-md'
//                                     type="email"
//                                     name='email'
//                                     placeholder='Email'
//                                     id='email'
//                                     required
//                                 />
//                             </div>

//                             {/* Password */}
//                             <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="password">Password</label>
//                                 <div className='relative flex items-center'>
//                                     <input
//                                         onChange={inputHandle}
//                                         value={state.password}
//                                         className='px-3 py-2 w-full outline-none border border-slate-400 bg-transparent rounded-md pr-10'
//                                         type={showPassword ? 'text' : 'password'}
//                                         name='password'
//                                         placeholder='Password'
//                                         id='password'
//                                         required
//                                     />
//                                     <button
//                                         type="button"
//                                         onClick={() => setShowPassword(prev => !prev)}
//                                         aria-label={showPassword ? 'Hide password' : 'Show password'}
//                                         className='absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-700'
//                                     >
//                                         {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
//                                     </button>
//                                 </div>
//                             </div>

//                             {/* Login Button */}
//                             <button
//                                 type="submit"
//                                 className='flex mb-3 gap-0.5 items-center justify-center px-8 w-full py-2 shadow-lg hover:shadow-green-500/40 text-white rounded-md'
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}
//                             >
//                                 <IoMdLogIn size={20} /> Customer Login
//                             </button>

//                             {/* Forgot Password */}
//                             <div className='w-full flex justify-center'>
//                                 <Link
//                                     to="/forgotPassword"
//                                     className='w-full flex p-2 border rounded-md text-md hover:underline text-center items-center justify-center'
//                                     style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}
//                                 >
//                                     <RiLockPasswordFill className='mr-1 text-[20px]' /> Forgot Password?
//                                 </Link>
//                             </div>

//                             {/* Divider */}
//                             <div
//                                 className='w-full h-[3px] mt-3 mb-3'
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}
//                             />

//                             {/* Register Link */}
//                             <a href={`${sellerFrontendURL}/register`}>
//                                 <div className='flex px-8 w-full py-2 mt-2 bg-green-700 shadow hover:shadow-red-500/50 text-white rounded-md justify-center items-center gap-1 mb-3'>
//                                     <FaUser size={16} /> New Customer Account
//                                 </div>
//                             </a>
//                         </form>

//                     </div>
//                 </div>
//             </div>

//             <Footer />
//         </div>
//     );
// };

// export default Login;




// my original code
// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaFacebookF, FaGoogle } from 'react-icons/fa6';
// import { FaFacebook, FaUser, FaUserCheck } from "react-icons/fa";
// import { RiLockPasswordFill } from "react-icons/ri";
// import { FiEye, FiEyeOff } from "react-icons/fi";
// import { IoMdLogIn } from "react-icons/io";

// //https://dev.to/annaqharder/hideshow-password-in-react-513a
// import { customer_login, messageClear } from '../store/reducers/authReducer';

// import Header from '../components/Header';
// import Footer from '../components/Footer';

// import { FadeLoader } from 'react-spinners';
// import toast from 'react-hot-toast';
// import config from '../config';

// const Login = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const sellerDashboardURL = config.STR_DASHBOARD_URL

//     const { seller } = useSelector(state => state.seller)
//     const { loader, errorMessage, successMessage, userInfo } = useSelector(state => state.auth);
        
//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1
        
//     const navigate = useNavigate();
//     const dispatch = useDispatch();

//     const [showPassword, setShowPassword] = useState(false);
//     const handleShowPasswordToggle = (e) => {
//         setShowPassword(!showPassword);
//     }

//    const inputFieldStyle = `
//                .inputField::-ms-reveal{
//                        display: 'none'
//                }`;
//     const [state, setState] = useState({
//         webSiteOrigin: sellerFrontendURL, email: '', password: ''
//     });
 
//     const inputHandle = (e) => {
//         setState({
//             ...state,
//             [e.target.name]: e.target.value
//         });
//         //console.log('state', state)
//     };
 
//     const login = (e) => {
//         e.preventDefault();
//         dispatch(customer_login(state));
//     };
 
//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//         if (userInfo) {
//             navigate('/');
//         }
//     }, [successMessage, errorMessage]);
 
//     return (
//         <div>
//             {
//                 loader && (
//                     <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]'>
//                         <FadeLoader />
//                     </div>
//                 )
//             }
//             <Header />
//             {/* login form  min-h-screen */}
//             <div className='min-w-screen bg-slate-200 flex justify-center items-center' >
//                 <div className='w-[350px] h-[360px] items-center m-8 flex justify-center'>
//                     <div className='bg-white text-[#ffffff] p-4 rounded-md shadow-lg'>
//                         <h2 className='flex gap-0.5 text-xl text-center items-center justify-center font-bold' style={{ color: sellerPrimaryColor1 }}>
//                            <IoMdLogIn size={25} /> Login
//                         </h2>
//                         <form onSubmit={login}>
//                             <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="email">Email</label>
//                                 <input onChange={inputHandle} value={state.email} 
//                                     className='px-3 py-2 outline-none border border-slate-400 bg-transparent rounded-md' 
//                                     type="email" name='email' placeholder='Email' id='email' required />
//                             </div>
//                             <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="password">Password</label>
//                                 {
//                                     //  <input onChange={inputHandle} value={state.password} 
//                                     // className='px-3 py-2 outline-none border border-slate-400 bg-transparent rounded-md' 
//                                     // type="password" name='password' placeholder='Password' id='password' required />
//                                 }
//                                 <div className='flex items-center' style={{ position: 'relative', width: '100%' }}>
//                                     <input onChange={inputHandle} value={state.password} 
//                                         className='hide-ms-reveal px-3 py-2 w-full outline-none border border-slate-400 bg-transparent rounded-md' 
//                                         type={showPassword ? 'text' : 'password'} name='password' placeholder='Password' id='password' required />
//                                     <span onClick={handleShowPasswordToggle}
//                                         style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
//                                             cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
//                                         {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
//                                     </span>
//                                 </div>
//                             </div>
//                             <button
//                                 className='flex mb-3 gap-0.5 items-center justify-center px-8 w-full py-2 shadow-lg hover:shadow-green-500/40 text-white rounded-md'
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <IoMdLogIn size={20} /> Customer Login
//                             </button>
//                             <div className='w-full flex border-none border-slate-700 text-center items-center justify-center justify-items-center'>
//                                 <Link to="/forgotPassword" 
//                                 className='w-full flex p-2 border rounded-md text-md hover:underline text-center items-center justify-center justify-items-center'
//                                     style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                     <RiLockPasswordFill className='mr-1 text-[20px]' /> Forgot Password?
//                                 </Link>
//                             </div>
                            
//                             <div className='w-full h-[3px] mt-3 mb-3' style={{backgroundColor:sellerPrimaryColor1}}></div>
//                             {/* flex  */}
//                             <div className='hidden items-center mb-3 mt-2 gap-3 justify-center' style={{ color: sellerPrimaryColor1 }}>
//                                 <p>Don't Have An Account? <Link className='font-bold' to="/register">Sign Up</Link></p> 
//                             </div>
//                             <a href={`${sellerFrontendURL}/register`}>
//                                  <div className='flex px-8 w-full py-2 mt-2 bg-green-700 shadow hover:shadow-red-500/50 text-white rounded-md 
//                                     justify-center items-center gap-1 mb-3'>
//                                     <FaUser size={16} /> New Customer Account
//                                 </div>
//                             </a>
//                             <a className='hidden' target='_blank' href={`${sellerDashboardURL}/login`}>
//                                 <div className='px-8 w-full py-2 bg-[#02e3e0] shadow hover:shadow-red-500/50 text-white rounded-md 
//                                     flex justify-center items-center gap-2 mb-3' style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                     <FaUser className='mr-2 mt-1' /> Login As a Seller
//                                 </div>
//                             </a>
//                             <a className='hidden' target='_blank' href={`${sellerDashboardURL}/register`}>
//                                 <div className='px-8 w-full py-2 bg-[#ad2cc4] shadow hover:shadow-red-500/50 text-white rounded-md 
//                                     flex justify-center items-center gap-2 mb-3'>
//                                     <FaUser className='mr-2 mt-1' /> Register As a Seller
//                                 </div>
//                             </a>
//                             <div className='hidden justify-center items-center gap-3'>
//                                 <div className='w-[135px] h-[35px] flex rounded-md bg-orange-700 shadow-lg hover:shadow-orange-700/50 justify-center cursor-pointer items-center overflow-hidden'>
//                                     <span><FaGoogle /></span>
//                                 </div>
//                                 <div className='w-[135px] h-[35px] flex rounded-md bg-blue-700 shadow-lg hover:shadow-blue-700/50 justify-center cursor-pointer items-center overflow-hidden'>
//                                     <span><FaFacebook /></span>
//                                 </div>
//                             </div>
//                         </form>
//                     </div>
//                 </div>  
//             </div>
//             <Footer />
//         </div>
//     );
// };
 
// export default Login;

 